import { resetButtonStylingCSS } from '@tmh-website/styles/global';
import StyledTypo from '@tmh-website/styles/typo';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';
import { AudienceTabThemeColor, audienceTabThemes } from './AudienceTab.theme';
import { Color } from '@tmh-website/shared/colors';

interface ContainerProps {
  $isChecked: boolean;
  $themeColor: AudienceTabThemeColor;
  $hasMargin: boolean;
  $inMenu: boolean;
}

export const Container = styled.button<ContainerProps>`
  ${resetButtonStylingCSS};
  ${StyledTypo.h6Css};
  margin: 0 -8px !important;
  font-size: 15px;
  color: ${props =>
    transparentize(
      props.$themeColor === Color.Blue_1000_Deep || props.$themeColor === Color.Purple_1000_Technology
        ? 0.6
        : props.$themeColor === Color.Blue_500_Ultramarine
        ? 0
        : 0.4,
      props.theme.color[audienceTabThemes[props.$themeColor].text.normal]
    )} !important;
  white-space: nowrap;
  border-radius: ${props => props.theme.borderRadius.small};
  transition: color ${props => props.theme.transitionTiming}, padding ${props => props.theme.transitionTiming},
    background-color 0.5s ease;

  ${props =>
    props.$inMenu &&
    css`
      padding: 8px;
    `}

  ${props =>
    !props.$inMenu &&
    css`
      padding: 6px 10px;
      ${props.$hasMargin && 'margin: 0 0 -0.5px !important;'}
      font-size: 13px;
      white-space: normal;
      background-color: ${props.theme.color[audienceTabThemes[props.$themeColor].background.normal]};
      border-radius: ${props.theme.borderRadius.small} ${props.theme.borderRadius.small} 0 0;
      @media (${props => props.theme.breakpoint.lg.up}) {
        padding: 6px 14px;
      }
    `}

  ${props =>
    props.$isChecked &&
    css`
      color: ${props.theme.color[audienceTabThemes[props.$themeColor].text.checked]} !important;
      background-color: ${props.theme.color[audienceTabThemes[props.$themeColor].background.checked]} !important;
    `};

  &:hover {
    text-decoration: none;
    background-color: ${props => props.theme.color[audienceTabThemes[props.$themeColor].background.hover]};
  }

  &:active {
    background-color: ${props => props.theme.color[audienceTabThemes[props.$themeColor].background.active]};
  }
`;
